import { FeeDistributor__factory } from '@contracts';
import { VenoSDKModule } from './base';
export default class FeeDistributorModule extends VenoSDKModule {
    constructor(sdk) {
        super(sdk);
        this.contractFactory = FeeDistributor__factory;
        this.contractAddress = this.sdk.addresses.feeDistributor;
    }
    async wcroToCurrRewardsPerBlock() {
        return await this.getContract().rewardTokenToCurrRewardsPerBlock(this.sdk.addresses.wcro);
    }
    async periodEndBlock() {
        return await this.getContract().periodEndBlock();
    }
}
